import { useEffect, useState } from 'react'
import { isMobileDevice } from 'Pages/orders_design'

export const useDeviceDetect = () => {
	const [isMobile, setMobile] = useState(false)

	useEffect(() => {
		setMobile(isMobileDevice())
	}, [])

	return { isMobile }
}
